import { useState, useContext } from "react";
import axios from "axios";
import Header from "../layout/Header";
import Footer from "../layout/Footer";
import { alertContext } from "../contexts/AlertProvider";
import Alert from "../Alert";

const ChangePassword = () => {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [alertConfig, setAlertConfig] = useContext(alertContext);
  const token = localStorage.getItem("token");
  const updatePassword = (event) => {
    event.preventDefault();
    axios
      .post(
        process.env.REACT_APP_API_ENDPOINT + "update-password",
        {
          oldPassword: oldPassword,
          newPassword: newPassword,
          confirmNewPassword: confirmNewPassword,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        if (res.data.code === 0) {
          setAlertConfig({
            show: true,
            message: res.data.message,
            type: "danger",
          });
        }
        if (res.data.code === 1) {
          setAlertConfig({
            show: true,
            message: res.data.message,
            type: "success",
          });
          reset();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const reset = () => {
    setOldPassword("");
    setNewPassword("");
    setConfirmNewPassword("");
  };
  return (
    <div className="d-flex flex-column flex-root">
      <Alert />
      {/*begin::Page*/}
      <div className="page d-flex flex-row flex-column-fluid">
        {/*begin::Wrapper*/}
        <div
          className="wrapper d-flex flex-column flex-row-fluid"
          id="kt_wrapper"
        >
          <Header />
          <div className="app-body">
            <div className="w-100 p-5">
              <div
                className="card my-4 my-xl-5 w-100 w-md-50 mx-auto"
              >
                {/*begin::Card header*/}
                <div
                  className="card-header border-0 cursor-pointer"
                  role="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#kt_account_profile_details"
                  aria-expanded="true"
                  aria-controls="kt_account_profile_details"
                >
                  {/*begin::Card title*/}
                  <div className="card-title m-0">
                    <h3 className="fw-bold m-0">Change Password</h3>
                  </div>
                  {/*end::Card title*/}
                </div>
                {/*begin::Card header*/}

                {/*begin::Content*/}
                <div
                  id="kt_account_settings_profile_details"
                  className="collapse show"
                >
                  {/*begin::Form*/}
                  <form
                    id="kt_account_profile_details_form"
                    className="form"
                    onSubmit={updatePassword}
                  >
                    {/*begin::Card body*/}
                    <div className="card-body border-top p-9">
                      {/*begin::Input group*/}
                      <div className="row mb-6">
                        {/*begin::Label*/}
                        <label className="col-lg-12 col-form-label required fw-semibold">
                          Old Password
                        </label>
                        {/*end::Label*/}

                        {/*begin::Col*/}
                        <div className="col-lg-12 mb-3 mb-lg-0">
                          <input
                            type={showPassword ? "text" : "password"}
                            className="form-control form-control-lg form-control-solid"
                            placeholder="Enter Old Password"
                            value={oldPassword}
                            onChange={(e) => {
                              setOldPassword(e.target.value);
                            }}
                          />
                        </div>
                        {/*end::Col*/}
                      </div>
                      {/*end::Input group*/}
                      {/*begin::Input group*/}
                      <div className="row mb-6">
                        {/*begin::Col*/}
                        <div className="col-lg-6 mb-3 mb-lg-0">
                          {/*begin::Label*/}
                          <label className="col-form-label required fw-semibold">
                            New Password
                          </label>
                          {/*end::Label*/}

                          <input
                            type={showPassword ? "text" : "password"}
                            className="form-control form-control-lg form-control-solid"
                            placeholder="Enter New Password"
                            value={newPassword}
                            onChange={(e) => {
                              setNewPassword(e.target.value);
                            }}
                          />
                        </div>
                        {/*end::Col*/}
                        {/*begin::Col*/}
                        <div className="col-lg-6 mb-3 mb-lg-0">
                          {/*begin::Label*/}
                          <label className="col-form-label required fw-semibold">
                            Confirm New Password
                          </label>
                          {/*end::Label*/}
                          <input
                            type={showPassword ? "text" : "password"}
                            className="form-control form-control-lg form-control-solid"
                            placeholder="Confirm New Password"
                            value={confirmNewPassword}
                            onChange={(e) => {
                              setConfirmNewPassword(e.target.value);
                            }}
                          />
                        </div>
                        {/*end::Col*/}
                      </div>
                      {/*end::Input group*/}
                    </div>
                    {/*end::Card body*/}

                    {/*begin::Actions*/}
                    <div className="card-footer d-flex justify-content-between py-6 px-9">
                      <button
                        onClick={() => {
                          setShowPassword(!showPassword);
                        }}
                        type="button"
                        className="btn btn-info"
                      >
                        {showPassword ? "Hide Password" : "Show Password"}
                      </button>
                      <div className="d-flex gap-2">
                        <button
                          type="button"
                          onClick={reset}
                          className="btn btn-light btn-active-light-primary ms-2"
                        >
                          Reset
                        </button>
                        <button
                          type="submit"
                          className="btn btn-primary"
                          id="kt_account_profile_details_submit"
                        >
                          Save Changes
                        </button>
                      </div>
                    </div>
                    {/*end::Actions*/}
                  </form>
                  {/*end::Form*/}
                </div>
                {/*end::Content*/}
              </div>
            </div>
          </div>

          <Footer />
        </div>
        {/*end::Wrapper*/}
      </div>
      {/*end::Page*/}
    </div>
  );
};

export default ChangePassword;
